import * as React from 'react';

export type CopyLinkIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Defaults to your original SVG fill (#222222) */
  color?: string;
};

function CopyLinkIcon({
  size = 19,
  title = 'Copy link',
  className,
  style,
  color = '#222222',
  ...spanProps
}: CopyLinkIconProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        lineHeight: 0,
        ...style,
      }}
      {...spanProps}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 19 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden
        focusable='false'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2663 8.17843C12.7665 9.682 12.7665 12.1162 11.2663 13.6198L7.32379 17.5623C5.82021 19.0626 3.38598 19.0626 1.88241 17.5623L1.43767 17.1176C-0.0625565 15.614 -0.0625565 13.1798 1.43767 11.6762L4.10849 9.00539C4.38165 8.73223 4.82454 8.73223 5.09771 9.00539C5.37087 9.27856 5.37087 9.72145 5.09771 9.99461L2.42689 12.6654C1.47217 13.6223 1.47217 15.1715 2.42689 16.1284L2.87162 16.5731C3.82867 17.5275 5.37752 17.5275 6.33457 16.5731L10.2771 12.6306C11.2318 11.6737 11.2318 10.1245 10.2771 9.16764L9.70495 8.59549C9.43179 8.32233 9.43179 7.87944 9.70495 7.60628C9.97812 7.33311 10.421 7.33311 10.6942 7.60628L11.2663 8.17843ZM17.5623 1.88241L17.1176 1.43767C15.614 -0.0625564 13.1798 -0.0625564 11.6762 1.43767L7.73369 5.38019C6.23346 6.88377 6.23346 9.318 7.73369 10.8216L8.30584 11.3937C8.48254 11.5704 8.7401 11.6394 8.98148 11.5748C9.22287 11.5101 9.41141 11.3215 9.47609 11.0802C9.54077 10.8388 9.47176 10.5812 9.29505 10.4045L8.7229 9.83236C7.76819 8.87545 7.76819 7.32632 8.7229 6.36941L12.6654 2.42689C13.6225 1.47251 15.1713 1.47251 16.1284 2.42689L16.5731 2.87162C17.5278 3.82853 17.5278 5.37766 16.5731 6.33457L13.9023 9.00539C13.6291 9.27856 13.6291 9.72144 13.9023 9.99461C14.1755 10.2678 14.6183 10.2678 14.8915 9.99461L17.5623 7.32379C19.0626 5.82021 19.0626 3.38598 17.5623 1.88241Z'
          fill={color}
        />
      </svg>
    </span>
  );
}

export default CopyLinkIcon;
